(function () {

  'use strict';

  function pxRegularExpression() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attributes, ngModelController) {

        ngModelController.$validators.pxRegularExpression = function (modelValue, viewValue) {
          const value = modelValue || viewValue;
          return isValidRegularExpression(value);
        };

        function isValidRegularExpression(regularExpression) {
          try {
            RegExp(regularExpression);
            return true;
          } catch (exception) {
            return false;
          }
        }

      }
    };
  }

  pxRegularExpression.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxRegularExpression', pxRegularExpression);

})();
